import cn from "@/lib/cn";
import { ICON_THEME_COLOR, IconTheme } from "@/components/icons/theme";

export type IconCaretButtonUpProps = {
  theme?: IconTheme;
  style?: "filled" | "outline";
  className?: string;
  title?: string;
};

interface IconCaretButtonUpSvgProps {
  className?: string;
  title?: string;
}

const THEME_COLOR = ICON_THEME_COLOR;

function DefaultSvg({ className, title }: IconCaretButtonUpSvgProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : "presentation"}
      aria-label={title}
      className={className}
    >
      <path d="M10.0733 9.92003L7.99332 7.84669L5.91999 9.92003L4.73999 8.74669L7.99332 5.48669L11.2467 8.74669L10.0733 9.92003Z" />
    </svg>
  );
}

function OutlineSvg({ className, title }: IconCaretButtonUpSvgProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : "presentation"}
      aria-label={title}
      className={className}
    >
      <path d="M10.3067 9.68663L7.99333 7.37329L5.68666 9.68663L4.97333 8.97996L7.99333 5.95996L11.0133 8.97996L10.3067 9.68663Z" />
    </svg>
  );
}

export default function IconCaretButtonUp({
  theme = "black",
  style = "filled",
  className,
  title,
}: IconCaretButtonUpProps) {
  const themeClassname = THEME_COLOR[theme];
  const Variant = style === "outline" ? OutlineSvg : DefaultSvg;

  return <Variant title={title} className={cn(className, themeClassname)} />;
}
